/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Which application the report was submitted from.
 * @export
 */
export const UserReportSource = {
    Studio: 'studio',
    Admin: 'admin'
} as const;
export type UserReportSource = typeof UserReportSource[keyof typeof UserReportSource];


export function instanceOfUserReportSource(value: any): boolean {
    for (const key in UserReportSource) {
        if (Object.prototype.hasOwnProperty.call(UserReportSource, key)) {
            if (UserReportSource[key as keyof typeof UserReportSource] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserReportSourceFromJSON(json: any): UserReportSource {
    return UserReportSourceFromJSONTyped(json, false);
}

export function UserReportSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserReportSource {
    return json as UserReportSource;
}

export function UserReportSourceToJSON(value?: UserReportSource | null): any {
    return value as any;
}

export function UserReportSourceToJSONTyped(value: any, ignoreDiscriminator: boolean): UserReportSource {
    return value as UserReportSource;
}

